import React, { useEffect, useState } from "react";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
import swal from "sweetalert";
const MeReport = (props) => {
    const [inputs, setInputs] = useState({});
    const Institutions = useFetchData("api/DashBoard/ApprovedInstitutions");
    const FinancialYears = useFetchData("api/FinancialYears");
    const [state, setState] = useState([]);
    const [responsemessage, setresponsemessage] = useState("");
    const [InstitutionId, setInstitutionId] = useState(window.sessionStorage.getItem("InstitutionId"));

    const fetchData = () => {
        setState([]);
        setresponsemessage(" ")
        let all = inputs.all ? inputs.all : false;
        let institutionID = inputs.institutionID ? inputs.institutionID : InstitutionId;
        let model = {
            fromdate: inputs.fromdate,
            all: all,
            InstitutionId: institutionID,
            todate: inputs.todate
        }
        let url = "api/EnrollmentPerInstitution/enrollmentasat";
        let data = JSON.stringify(model)

        Api.post(url, data)
            .then((response) => {
                if (response.data.length == 0) {
                    setresponsemessage("No data found")
                }
                setState(response.data)

            }, (error) => {
                swal("", "Failed", "error");
            });

    };
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const handlePrint = () => {
        let all = inputs.all ? inputs.all : false;
        let institutionID = inputs.institutionID ? inputs.institutionID : InstitutionId;
        let model = {
            fromdate: inputs.fromdate,
            all: all,
            InstitutionId: institutionID,
            todate: inputs.todate
        }
        let uri = "api/EnrollmentPerInstitution/report/enrollmentasat";

        Api.post(uri, JSON.stringify(model), { responseType: 'blob' })
            .then((response) => {
                console.log(response)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Enrollment Per Institution As At.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });;;
    }
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
    };
    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    const InstitutionsOptions = [];

    if (Institutions.response) {
        Institutions.response.map((k, i) => {
            let col = {
                value: k.id,
                label: k.name,
            };
            InstitutionsOptions.push(col);
        });
    }
    const FinancialYearOptions = [];
    if (FinancialYears.response) {
        FinancialYears.response.map((k, i) => {
            let col = {
                value: k.id,
                label: k.description,
            };
            FinancialYearOptions.push(col);
        });
    }
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Enrollment as At</li>
            </ol>
            <h1 class="page-header mb-3"> Enrollment as At</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="col-sm-12">
                    <div className="row" style={{ paddingTop: "15px" }}>

                        {window.sessionStorage.getItem("securitygroup") ===
                            "Institution Administrator" ? null : <div className="col-sm-4">
                            <div class="form-group row m-b-15">
                                <label class="col-form-label col-md-3">Institution</label>
                                <div class="col-md-9">
                                    <Select
                                        name="institutionID"
                                        value={InstitutionsOptions.filter(
                                            (option) => option.value === inputs.institutionID
                                        )}
                                        //defaultInputValue={inputs.securityGroupId}
                                        onChange={handleSelectChange}
                                        options={InstitutionsOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        }
                         {window.sessionStorage.getItem("securitygroup") ===
                            "Institution Administrator" ? null : <div className="col-sm-1">
                            <div class="form-group row m-b-15">
                                <label class="col-form-label col-md-6">All</label>
                                <div class="col-md-6">
                                    {/* <br/> */}
                                    <input
                                        style={{ marginTop: "12px" }}
                                        className="checkbox"
                                        type="checkbox"
                                        name="all"
                                        defaultChecked={inputs.all}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>}
                        <div className="col-sm-3">
                            <div class="form-group row m-b-15">
                                <label class="col-form-label col-md-3">From Date</label>
                                <div class="col-md-9">
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fromdate"
                                        required
                                        value={inputs.fromdate}
                                        onChange={handleInputChange}
                                    // defaultvalue={inputs.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div class="form-group row m-b-15">
                                <label class="col-form-label col-md-3">To Date</label>
                                <div class="col-md-9">
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="todate"
                                        required
                                        value={inputs.todate}
                                        onChange={handleInputChange}
                                    // defaultvalue={inputs.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <button
                                className="btn btn-primary"
                                style={{ float: "left" }}
                                onClick={fetchData}
                            >
                                Load
                            </button>
                        </div>
                    </div>
                </div>
                <hr />
                {state.length > 0 ? (
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-3">
                                {state.length > 0 ?
                                    <button
                                        onClick={handlePrint}
                                        className="btn btn-secondary p-2"
                                        style={{ marginRight: 5, marginTop: 5 }}
                                    >
                                        &nbsp; Print \ Export &nbsp;
                                    </button> : null}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <h5 className="text-center">MINISTRY OF EDUCATION</h5>
                                <h5 className="text-center">
                                    TECHNICAL AND VOCATIONAL EDUCATION AND TRAINING
                                </h5>
                                <h5 className="text-center">ENROLLMENT AS AT {inputs.fromdate} - {inputs.todate}</h5>
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col " colspan="2" className="text-center" >Year 1</th>
                                            <th scope="col" colspan="2" className="text-center"  >Year 2</th>
                                            <th scope="col" colspan="2" className="text-center" >Year 3</th>
                                            <th scope="col" className="text-center" >Total</th>
                                        </tr>
                                        <tr>
                                            <th scope="col">Institution </th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Male</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Female</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Male</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Female</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Male</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Female</th>
                                            <th scope="col" style={{ textAlign: 'right' }}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state.map((k) => {
                                            return (
                                                <tr>
                                                    <td>{k.name}</td>
                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y1Male)}</td>
                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y1Female)}</td>

                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y2Male)}</td>
                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y2Female)}</td>

                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y3Male)}</td>
                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.y3Female)}</td>
                                                    <td style={{ textAlign: 'right' }}>{numberWithCommas(k.total)}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>Total</td>
                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y1Male, 0))}</td>
                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y1Female, 0))}</td>

                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y2Male, 0))}</td>
                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y2Female, 0))}</td>

                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y3Male, 0))}</td>
                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.y3Female, 0))}</td>

                                            <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.total, 0))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                        </div>
                    </div>
                ) : null}
                <h3>{responsemessage}</h3>
            </div>
        </div>
    );
};
export default MeReport;
